module.exports = __webpack_public_path__ + "assets/f4d0c1ecf63f06bc8d7df0e4b30c5319.png";